import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { TermsOfServicePageContent } from '@/components/termsOfService/TermsOfServicePageContent';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/faq';
import { Box } from '@lemonade-hq/cdk';
import { DocumentTypes } from 'contentlayer/generated';
import type React from 'react';
import styled from 'styled-components';

const ContentWrapper = styled(Box)`
  position: relative;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

interface TermsOfServicePageTemplateProps {
  config: Config;

  showHeader?: boolean;
  showFooter?: boolean;
}

export const TermsOfServicePageTemplate: React.FC<TermsOfServicePageTemplateProps> = ({
  config,
  showHeader,
  showFooter,
}) => {
  useShowHeaderCtaOnScroll(true);

  return (
    <>
      <SEO {...config.seo} />
      <Layout
        pt={[70, 60, 120]}
        headerActions={config.layout.headerActions}
        showHeader={showHeader}
        showFooter={showFooter}
      >
        <ContentWrapper px="20px" pb="40px">
          <TermsOfServicePageContent content={config.MDXContent as DocumentTypes} />
        </ContentWrapper>
      </Layout>
    </>
  );
};
